var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.424 17.9059C15.2518 17.9862 15.0604 18.016 14.8719 17.9919C14.6834 17.9678 14.5056 17.8909 14.359 17.7699L8.35904 12.7699C8.24615 12.6761 8.15531 12.5586 8.09296 12.4256C8.03061 12.2927 7.99829 12.1477 7.99829 12.0009C7.99829 11.8541 8.03061 11.7091 8.09296 11.5762C8.15531 11.4433 8.24615 11.3258 8.35904 11.2319L14.359 6.23194C14.5401 6.0846 14.7666 6.00471 15 6.00594C15.1467 6.00579 15.2915 6.03824 15.424 6.10094C15.5961 6.18149 15.7417 6.30939 15.8437 6.46967C15.9457 6.62994 15.9999 6.81596 16 7.00594L16 17.0059C15.999 17.1951 15.9443 17.38 15.8423 17.5393C15.7404 17.6986 15.5953 17.8258 15.424 17.9059ZM14 9.14094L10.562 12.0059L14 14.8709L14 9.14094Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 9.14094L10.562 12.0059L14 14.8709L14 9.14094Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.943c6fe9684a8408b6496ba847c5e51f.svg";
export { ForwardRef as ReactComponent };